import { 
  GET_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  GET_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  GET_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS, 
  UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR,
  UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

export const getClicksDashboardStickyColumns = () => {
  return {
    type: GET_CLICKS_DASHBOARD_STICKY_COLUMNS,
  }
}

export const getClicksDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getClicksDashboardStickyColumnsError = error => {
  return {
    type: GET_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateClicksDashboardStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateClicksDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateClicksDashboardStickyColumnsError = error => {
  return {
    type: UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}